var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wonder-player"},[_c('video',{staticClass:"one-player",attrs:{"id":"player-container-wonder","preload":"auto","playsinline":"","webkit-playsinline":""}})])
}]

export { render, staticRenderFns }